var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32615)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#104FCA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.9375 5.38208L6.31913 9.37752V13.5001C5.004 13.5001 3.9375 12.4673 3.9375 11.1933V5.38208Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6803 9.37307L14.0608 5.37988H14.0619V11.1939C14.0625 12.4674 12.996 13.5001 11.6803 13.5001V9.37307Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.99831 9.25768L7.8075 11.2557C7.56056 11.1938 7.29506 10.9542 7.011 10.5374L3.9375 5.38206C5.07656 4.74474 6.53344 5.12331 7.191 6.22581L8.99831 9.25768Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.809 6.22134C11.4666 5.11772 12.9234 4.73972 14.0625 5.37703L10.989 10.5323C10.767 10.8541 10.4698 11.1169 10.1231 11.2976C9.77649 11.4784 9.39093 11.5718 8.99999 11.5696C8.62978 11.5703 8.26427 11.4866 7.93125 11.3249L7.8075 11.2557L10.809 6.22134Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32615"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMth);
export default __webpack_public_path__ + "static/media/mth.bf5b35d6ce961dcd3398a09f6a429e69.svg";
export { ForwardRef as ReactComponent };